import React, { useState, useEffect } from 'react';
import { IoMdClose } from "react-icons/io";
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // Import the new spinner icon

const ChangeSalesMan = ({ requestId, currentSalesman, onClose, callFunc, type }) => {
    const [salesmen, setSalesmen] = useState([]);
    const [selectedSalesman, setSelectedSalesman] = useState('');
    const [noSalesmenMessage, setNoSalesmenMessage] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false); 
    // Log to verify
    useEffect(() => {
      
    }, [requestId, currentSalesman, type]);
  
    // Fetch salesmen based on the type (Medicine/Cosmetic)
    useEffect(() => {
      const fetchSalesmenByType = async () => {
        try {
          const response = await fetch(SummaryApi.getSalesmenByType.url, {
            method: SummaryApi.getSalesmenByType.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ type }),
          });
  
          const result = await response.json();
  
          if (result.success) {
            if (result.data.length === 0) {
              setNoSalesmenMessage('لا يوجد مسئولين مبيعات لهذه الشركة حاليا');
              setSalesmen([]);
            } else {
              setNoSalesmenMessage('');
              setSalesmen(result.data);
            }
          } else {
            toast.error(result.message || 'Failed to fetch salesmen');
          }
        } catch (error) {
        }
        finally {
          setButtonLoading(false); // Stop button loading after the process
      }
      };
  
      fetchSalesmenByType();
    }, [type]);
  
    // Handle submit to change salesman
    const handleSubmit = async () => {
      setButtonLoading(true);

      try {
        const response = await fetch(`${SummaryApi.adminEditOrderSalesman.url}/${requestId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ newStatus: selectedSalesman, type }),
          credentials: 'include',
        });
  
        const responseData = await response.json();
        if (responseData.success) {
          toast.success('تم تغيير مندوب المبيعات بنجاح');
          callFunc();
          onClose();
        } else {
          toast.error(responseData.message || 'فشل في تغيير مندوب المبيعات.');
        }
      } catch (error) {
        
        toast.error('فشل في تغيير مندوب المبيعات.');
      }
    };
  
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex justify-center items-center">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold mb-4 ">تغيير مندوب المبيعات</h2>
            <button onClick={onClose}>
              <IoMdClose className="text-2xl" />
            </button>
          </div>
  
          {noSalesmenMessage ? (
            <p>{noSalesmenMessage}</p>
          ) : (
            <div>
              <label className="block text-sm font-medium mb-2 text-right">: اختر مندوب مبيعات</label>
              <select
                className="w-full p-2 border border-gray-300 rounded-md"
                value={selectedSalesman}
                onChange={(e) => setSelectedSalesman(e.target.value)}
              >
                <option value="">اختر مندوب مبيعات</option>
                {salesmen.map((salesman) => (
                  <option key={salesman._id} value={salesman._id}>
                    {salesman.name}
                  </option>
                ))}
              </select>
              <button
            className={`mt-4 py-2 px-4 bg-blue-800 hover:bg-blue-600 text-white rounded ${buttonLoading || !selectedSalesman ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={handleSubmit}
            disabled={buttonLoading || !selectedSalesman} 
        >
            {buttonLoading ? <AiOutlineLoading3Quarters className="animate-spin" /> : 'حفظ'}
        </button>


            </div>
          )}
        </div>
      </div>
    );
  };
  
  export default ChangeSalesMan;
  
